import { useDispatch } from 'react-redux';
import { FlexContainer, Text, Buttons, Icon } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { hideModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { CloseIcon } from 'Components/icons';
import Trans from 'Components/Trans';
import { removeOverflow } from 'Styles/utils/utils';
import * as Styled from './styles';

const TaxSeasonInfo = ({ data }: { data: { route: string } }): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.DASHBOARD);

  const handleCloseModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
  };

  const handleClick = (): void => {
    history.push(data.route);
    handleCloseModal();
  };
  return (
    <Styled.ModalContainer align="center" justify="center">
      <Styled.ModalContent direction="column">
        <Styled.Container direction="column">
          <FlexContainer align="flex-end" justify="flex-end">
            <Styled.CloseButton onClick={handleCloseModal}>
              <CloseIcon />
            </Styled.CloseButton>
          </FlexContainer>
          <Text type="fds_heading_bold_H5" size="fds_size_32" align="center">
            {t('TaxSeason.Info.Title')}
          </Text>
          <Styled.Banner mb="fds_size_16" mt="fds_size_16" id="success" direction="column">
            <FlexContainer align="center" gap="dimension_08" mb="fds_size_16">
              <Icon icon="IconInfoSolidSDark" color="active" />
              <Text type="paragraphs" color="success_strong" size="M_M_S">
                {t('TaxSeason.Info.banner.title')}
              </Text>
            </FlexContainer>
            <Text type="paragraphs" color="fresh" size="S_M_M">
              <Trans
                ns={locizeNS.DASHBOARD}
                components={{
                  ul: <ul />,
                  li: <li />,
                  br: <br />,
                  span: <span />,
                }}
                i18nKey={t('TaxSeason.Info.Banner')}
              />
            </Text>
          </Styled.Banner>
          <Buttons.Classic
            onClick={handleClick}
            label={t('TaxSeasonInfo.continue')}
            mode="primary"
            size="l"
          />
        </Styled.Container>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default TaxSeasonInfo;
